import { TextInput, MaskedInput, Select } from "components/inputs";

import type { SubPageType } from "types/FormTypes";
import type { ConstantTypes } from "types/DataTypes";

export const getInsurerForm = (
  constants: ConstantTypes,
  readOnly: boolean,
): SubPageType[] => {
  return [
    {
      name: "Insurers",
      stepNumber: 1,
      path: "insurers/:insurerId/overview",
      cards: [
        {
          cardNumber: 1,
          cardName: "Insurer Information",
          fields: [
            {
              label: "Name",
              component: TextInput,
              apiField: "name",
              componentProps: {
                placeholder: "Name",
                readOnly,
                disabled: readOnly,
              },
            },
          ],
        },
        {
          cardNumber: 2,
          cardName: "Address",
          fields: [
            {
              label: "Address",
              component: TextInput,
              apiField: "address",
              componentProps: {
                placeholder: "Street Address",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "State",
              component: Select,
              apiField: "state",
              componentProps: {
                placeholder: "Select State",
                options: constants?.STATES,
                isDisabled: readOnly,
              },
            },
            {
              label: "ZIP Code",
              component: MaskedInput,
              apiField: "zipcode",
              componentProps: {
                placeholder: "ZIP Code",
                readOnly,
                disabled: readOnly,
                mask: "zipcode",
              },
            },
          ],
        },
        {
          cardNumber: 3,
          cardName: "History",
          fields: [
            {
              label: "Created Date",
              component: TextInput,
              apiField: "created",
              componentProps: {
                readOnly: true,
                roundDate: true,
              },
            },
            {
              label: "Last Updated Date",
              component: TextInput,
              apiField: "modified",
              componentProps: {
                readOnly: true,
                roundDate: true,
              },
            },
          ],
        },
      ],
    },
  ];
};
